import {assert} from 'Asserts';

import areAminoAcidsValid from './areAminoAcidsValid';
import ProteinConstants from './ProteinConstants';

const getAminoAcidFrequency = (aminoAcids: string): Map<string, number> => {
  const upperAminoAcids = aminoAcids.toUpperCase();
  assert(areAminoAcidsValid(upperAminoAcids), 'Cannot get frequency for invalid amino acids');

  const aminoAcidToCount = new Map();

  ProteinConstants.ALL_AMINO_ACIDS.forEach((aminoAcid) => {
    aminoAcidToCount.set(aminoAcid, 0);
  });

  for (const aminoAcid of upperAminoAcids) {
    const currentCount = aminoAcidToCount.get(aminoAcid);
    aminoAcidToCount.set(aminoAcid, currentCount + 1);
  }

  return aminoAcidToCount;
};

export default getAminoAcidFrequency;
